import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { deleteSeries, SERIES_QUERY_KEY } from "./api";

interface DeleteSeriesParams {
  seriesId: string;
  venuePageId: string;
}

/**
 * Hook to delete a series
 */
export function useDeleteSeries(): UseMutationResult<
  void,
  Error,
  DeleteSeriesParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ seriesId }: DeleteSeriesParams) => deleteSeries(seriesId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SERIES_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
